import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { MediaDownloadUrlDto } from '@/types/dtos/media/media-download-url.dto.ts';

export const useGetMediaDownloadUrlMutation = () => {
  const { getToken } = useAuth();
  return useMutation({
    mutationFn: async (downloadMediaUri: string): Promise<MediaDownloadUrlDto> => {
      const token = await getToken();
      const data = await sendJSONRequest({
        url: downloadMediaUri,
        method: METHOD.GET,
        token: token || '',
      });
      if (!data?.url || typeof data.url !== 'string') {
        throw new Error('No download URL in response');
      }
      return { url: data.url };
    },
  });
};
